module.exports = __webpack_public_path__ + "static/product-c38239ad9398a0b1d904999f78a341e2.png";